// extracted by mini-css-extract-plugin
module.exports = {"dragImage":"DragImage_dragImage__qDDjC bodyS"};